export const LEVEL_SURFACE_GRID_GAP = 6;
export const LEVEL_SURFACE_DEFAULT_HREF = "/(nav)/(app)/browse/morpheme/[morpheme]";
